import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import * as globals from '@reusable/services/globals';
import { map } from 'rxjs/operators';

@Injectable()
export class TeamCoreBrandsService {
  responseData: any;
  handleError: any;

  constructor(private router: Router, private gtn: globals.GetTokenNow, private httpClient: HttpClient) {}

  viewCoreBrand(coreBrandId) {
    return this.httpClient.get(`${globals.domain}/core/parts-brands/${coreBrandId}/view`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  editCoreBrand(coreBrandId) {
    return this.httpClient.get(`${globals.domain}/core/parts-brands/${coreBrandId}/edit/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  updateCoreBrand(coreBrandId, body) {
    return this.httpClient
      .put(`${globals.domain}/core/parts-brands/${coreBrandId}/update/`, JSON.stringify(body), this.gtn.getHeaders())
      .pipe(map(res => res as any));
  }
  // requestId ,
  addCoreBrand(body) {
    return this.httpClient.post(`${globals.domain}/core/parts-brands/add/`, JSON.stringify(body), this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  removeCoreBrand(coreBrandId) {
    return this.httpClient.delete(`${globals.domain}/core/parts-brands/${coreBrandId}/remove/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  restoreCoreBrand(coreBrandId) {
    return this.httpClient.put(`${globals.domain}/core/parts-brands/${coreBrandId}/restore/`, {}, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  rearrangeCoreBrand(body) {
    return this.httpClient.put(`${globals.domain}/core/parts-brands/rearrange/`, JSON.stringify(body), this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  listCoreBrands(sort, records, pageNumber, queries?) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/core/parts-brands/list/sortBy-${sort}/${records}/${pageNumber}/`, updateQueries)
      .pipe(map(res => res as any));
  }
  searchCoreBrands(sort, records, pageNumber, keyword, queries?) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/core/parts-brands/search/sortBy-${sort}/${records}/${pageNumber}/${keyword}`, updateQueries)
      .pipe(map(res => res as any));
  }
}